import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {PagedRequest} from "../../models/paged-request.model";

const API_USERS_URL = `${environment.apiUrl}/Users`;

@Injectable({
    providedIn: 'root',
})
export class UserService {
    constructor(private http: HttpClient) {
    }

    getUsers(prInput: PagedRequest): Observable<any> {
        let params = new HttpParams({fromObject: prInput as any});
        return this.http.get(API_USERS_URL + `/GetUsers`, {params});
    }

    addUser(input: any): Observable<any> {
        return this.http.post(API_USERS_URL + '/AddUser', input);
    }

    updateUser(input: any): Observable<any> {
        return this.http.put(API_USERS_URL + '/UpdateUser', input);
    }

    removeUser(id: number): Observable<any> {
        return this.http.delete(API_USERS_URL + '/RemoveUser/' + id);
    }

    getUserPhoto(id: number): Observable<any> {
        return this.http.get(API_USERS_URL + '/GetUserPhoto/' + id);
    }

    updateUserDetailFromMernis(id: number): Observable<any> {
        debugger;
        return this.http.post(API_USERS_URL + '/UpdateUserDetailFromMernis/' + id, null);
    }

    updateEducationInformationFromYoksis(id: number): Observable<any> {
        debugger;
        return this.http.post(API_USERS_URL + '/UpdateEducationInformationFromYoksis/' + id, null);
    }
}
